import { Tag } from "bbcode-to-react";
import * as React from "react";
function nop() {
    // nop
}
class TooltipTag extends Tag {
    toHTML() {
        return [this.getContent()];
    }
    toReact() {
        const { tooltip } = this.params;
        return (React.createElement("a", { onClick: nop, title: tooltip }, this.getComponents()));
    }
}
export default TooltipTag;
